import { IProperty } from '@kaaja/data-models';
import { orderByTitleAsInteger } from '../../shared/commonUtils';

export const orderImagesAndPlanimetries = (property: IProperty): IProperty => ({
  ...property,
  images: orderByTitleAsInteger(property.images) || [],
  planimetries: orderByTitleAsInteger(property.planimetries || []) || [],
});
